export function showNotification(notification_id, body) {
  $("#notifications-container").append(body);
  $(`#${notification_id}`).toast('show');
}